export const SEO_ENRICHER_INTENTS = [
  'pricing_fare',
  'fare_inclusions',
  'booking_process',
  'booking_modification',
  'cab_type_selection',
  'luggage_capacity',
  'route_distance_duration',
  'toll_charges',
  'night_travel',
  'airport_transfer',
  'sightseeing_tourism',
  'safety_comfort',
  'cancellation_refund',
  'waiting_time_policy',
  'multi_stop_trip',
  'cab_comparison',
  'group_travel',
  'driver_quality',
  'driver_cab_assignment',
  'payment_options',
  'general_inquiry'
] as const;

export type SeoEnricherIntent = typeof SEO_ENRICHER_INTENTS[number];

export const SEO_ENRICHER_INTENT_COLORS: Record<SeoEnricherIntent, string> = {
  pricing_fare: '#7c3aed',
  fare_inclusions: '#0c58b4',
  booking_process: '#16a34a',
  booking_modification: '#2563eb',
  cab_type_selection: '#0d9488',
  luggage_capacity: '#2563eb',
  route_distance_duration: '#dc6b30',
  toll_charges: '#d97706',
  night_travel: '#7c3aed',
  airport_transfer: '#2563eb',
  sightseeing_tourism: '#dc6b30',
  safety_comfort: '#0c58b4',
  cancellation_refund: '#db2777',
  waiting_time_policy: '#d97706',
  multi_stop_trip: '#16a34a',
  cab_comparison: '#7c3aed',
  group_travel: '#7c3aed',
  driver_quality: '#0d9488',
  driver_cab_assignment: '#2563eb',
  payment_options: '#0d9488',
  general_inquiry: '#7c3aed'
};

export const SEO_ENRICHER_DEFAULT_INTENT_COLOR = '#8a8a99';

const FALLBACK_INTENT_COLORS = [
  '#d97706',
  '#2563eb',
  '#7c3aed',
  '#dc6b30',
  '#0d9488',
  '#0c58b4',
  '#db2777',
  '#16a34a'
];

export const isSeoEnricherIntent = (
  value: string
): value is SeoEnricherIntent =>
  SEO_ENRICHER_INTENTS.some(intent => intent === value);

export const getSeoEnricherIntentColor = (
  intent: SeoEnricherIntent | null,
  fallbackIdx = 0
) =>
  intent
    ? SEO_ENRICHER_INTENT_COLORS[intent]
    : FALLBACK_INTENT_COLORS[fallbackIdx % FALLBACK_INTENT_COLORS.length];
